import { notFound } from "next/navigation";
import { Heading, Spinner, Switch, Text } from "ui-components";

import { makeToast } from "@/src/components/Toast/Toast";
import {
  useUserGetProfile,
  useUserUpdateUserSettings,
} from "@/src/hooks/api/generated";
import { brazeNewsletterNotification } from "@/utils/brazeClient";

export default function MyNewsletterSettings(): JSX.Element {
  const { data, isLoading, refetch } = useUserGetProfile();
  const { mutate: updateSettings } = useUserUpdateUserSettings();

  function handleChange(isSelected: boolean): void {
    updateSettings(
      {
        data: {
          is_subscribed_to_newsletter: isSelected,
        },
      },
      {
        onSuccess: () => {
          refetch();
          makeToast({
            title: "Settings updated successfully.",
            intent: "success",
          });
          if (data?.uuid) {
            brazeNewsletterNotification(isSelected, data.uuid);
          }
        },
        onError: () => {
          makeToast({
            title: "Something went wrong.",
            intent: "danger",
          });
        },
      }
    );
  }

  if (isLoading) {
    return (
      <div className="flex justify-center mt-10">
        <Spinner size="lg" intent="brand-primary" />
      </div>
    );
  }

  if (!data) {
    return notFound();
  }

  return (
    <div className="w-full flex flex-col gap-y-20">
      <div className="flex flex-col items-center gap-y-5">
        <Heading variant="h3">Subscribe to our newsletter</Heading>
        <div className="w-[597px] text-center">
          <Text>
            I want to subscribe to myGwork&apos;s newsletter and receive regular
            community updates.
          </Text>
        </div>
        <Switch
          isSelected={data.userSetting.is_subscribed_to_newsletter}
          onChange={(isSelected) => handleChange(isSelected)}
        />
      </div>
    </div>
  );
}
